import React, { FC, useEffect, useState } from "react";
import { Alert, Button, Spin } from "antd";
import {
  useCheckFortnoxConnectionQuery,
  useGetLoginFortnoxUrlQuery,
} from "shared/api";

const FortnoxHeader: FC = () => {
  const { data: connectionStatus, isLoading: isCheckingConnection } =
    useCheckFortnoxConnectionQuery();
  const [shouldFetchUrl, setShouldFetchUrl] = useState(false);

  const { data: loginUrlData, isLoading: isLoadingUrl } =
    useGetLoginFortnoxUrlQuery(undefined, {
      skip: !shouldFetchUrl,
    });

  useEffect(() => {
    if (loginUrlData?.url) {
      window.location.href = loginUrlData.url;
      setShouldFetchUrl(false);
    }
  }, [loginUrlData]);

  const handleLoginClick = () => {
    setShouldFetchUrl(true);
  };

  if (isCheckingConnection) {
    return (
      <div className="mb-4">
        <Spin size="small" />
      </div>
    );
  }

  const isConnected = connectionStatus?.ok === true;
  const errorMessage = connectionStatus?.error || "Not connected";

  return (
    <div className="mb-4">
      <Alert
        message={
          <div className="flex items-center justify-between">
            <span>
              {isConnected ? (
                <span className="font-medium text-green-600">
                  Login to Fortnox:{" "}
                  <span className="text-green-700">Logged In</span>
                </span>
              ) : (
                <span className="font-medium text-red-600">
                  Login to Fortnox:{" "}
                  <span className="text-red-700">Not Logged In</span>
                  {errorMessage && errorMessage !== "Not connected" && (
                    <span className="ml-2 text-sm">({errorMessage})</span>
                  )}
                </span>
              )}
            </span>
            {!isConnected && (
              <Button
                type="primary"
                size="small"
                onClick={handleLoginClick}
                loading={isLoadingUrl}
                className="ml-4"
              >
                Login to Fortnox
              </Button>
            )}
          </div>
        }
        type={isConnected ? "success" : "error"}
        showIcon
        className="border-2"
      />
    </div>
  );
};

export { FortnoxHeader };
